import { Pipe, PipeTransform } from "@angular/core";

//import moment from "moment";

@Pipe({
  name: "discDateStatusTransform",
})
export class DiscDateStatusTransformPipe implements PipeTransform {
  /**
   * Takes a datetime and return active or discontinue
   * If the date is after or equals current date return Discontinued
   * Else the date is before current date return Active
   */
  transform(discontinueDate: string, type: string) {
    if (discontinueDate === null) {
      return "Active";
    }
    switch (type) {
      case "Intake":
        return "-";
      default:
        return discontinueDate
          ? Date.parse(discontinueDate) > new Date().valueOf()
            ? "Active"
            : "Discontinued"
          : "Active";
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/disc-date-status-transform.ts